import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import Select, { SelectComponents } from '@lib/components/Select/Select';
import MultiSelectValueContainer from '@lib/components/Select/components/MultiSelectValueContainer';
import { GetLoadOptions } from '@lib/components/Select/types';
import generateIdsFieldKey from '@lib/utils/generateIdsFieldKey';
import {
  FieldChangeCallBackArgs,
  FieldItem,
  Values,
} from '@lib/interfaces/form';
import { getOptionsArrayValidation } from '@lib/utils/validationUtils';

type Props = {
  getFormCategoriesLoadOptions: GetLoadOptions;
  getTemplatesLoadOptions: GetLoadOptions;
  fieldNameFormCategory: string;
  fieldNameFormTemplateName: string;
};

export default function useFilterFields({
  getFormCategoriesLoadOptions,
  getTemplatesLoadOptions,
  fieldNameFormCategory,
  fieldNameFormTemplateName,
}: Props): FieldItem[] {
  const { t } = useTranslation();
  return [
    {
      name: fieldNameFormCategory,
      label: t('form-categories-label'),
      element: Select,
      validation: getOptionsArrayValidation({ t }),
      componentProps: {
        defaultOptions: false,
        isAsync: true,
        isMulti: true,
        getLoadOptions: getFormCategoriesLoadOptions,
        maxMenuHeight: 200,
        usePortal: true,
        components: {
          ValueContainer: MultiSelectValueContainer,
        } as unknown as SelectComponents,
      },
      isOptionalFn: () => false,
      fieldChangeCallBack: ({ setValue, name }: FieldChangeCallBackArgs) => {
        if (name === fieldNameFormCategory) {
          setValue(fieldNameFormTemplateName, null, { shouldValidate: false });
        }
      },
    },
    {
      name: fieldNameFormTemplateName,
      label: t('form-template-names-label'),
      element: Select,
      validation: getOptionsArrayValidation({ t }),
      componentProps: {
        defaultOptions: false,
        isAsync: true,
        isMulti: true,
        getLoadOptions: getTemplatesLoadOptions,
        maxMenuHeight: 200,
        usePortal: true,
        components: {
          ValueContainer: MultiSelectValueContainer,
        } as unknown as SelectComponents,
      },
      isOptionalFn: () => false,
      getFieldKeyFn: (values: Values) => {
        const formCategories = _get(values, fieldNameFormCategory, []) as Array<
          { value?: string } | string
        >;
        return generateIdsFieldKey(formCategories, {
          prefix: `${fieldNameFormTemplateName}-${fieldNameFormCategory}`,
          emptyKey: `${fieldNameFormTemplateName}-no-${fieldNameFormCategory}`,
        });
      },
    },
  ];
}
